import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProjectDeliveryLog } from '../../../api';
export default {
  name: 'ApplyLogPanel',
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      logSearchForm: {
        id: this.id,
        pageSize: 20,
        page: 1
      },
      logList: [],
      logPages: {
        currentPage: 1,
        totalCount: 0
      }
    };
  },
  created: function created() {
    this.handlePageChange(1);
  },
  methods: {
    getLog: function getLog() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getProjectDeliveryLog(_this.logSearchForm);
            case 1:
              res = _context.v;
              _this.logList = res.data;
              _this.logPages = res.pages;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handlePageChange: function handlePageChange(page) {
      this.logSearchForm.page = page;
      this.getLog();
    },
    sizeChange: function sizeChange(size) {
      this.logSearchForm.pageSize = size;
      this.handlePageChange(1);
    }
  }
};